import Dashboard from "layouts/Dashboard.jsx";
import External from "layouts/External.jsx";
import Monitoring from "../layouts/Monitoring";
import { NotClient } from "./dashboard";

var indexRoutes = [
  { path: "/(login|lockedOut|requestReset|otp|reset)", name: "External", component: External },
  //{ path: "/monitoring", name: "Monitoring", component: Monitoring, private: true, roles: NotClient },
  { path: "/", name: "Home", component: Dashboard, private: true }
];

export default indexRoutes;
